import { useState } from "react";

const useCollapse = () => {
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapse = () => setCollapsed(!collapsed);
  return { collapsed, toggleCollapse };
};

export default useCollapse;
